(function () {
  'use strict';

  function initSeeItWork(section) {
    if (!section) return;

    if (section.dataset.seeItWorkInitialized === 'true') {
      return;
    }

    section.dataset.seeItWorkInitialized = 'true';

    const track = section.querySelector(
      '[data-see-it-work-track]'
    );

    const slides = Array.from(
      section.querySelectorAll(
        '[data-see-it-work-slide]'
      )
    );

    const dots = Array.from(
      section.querySelectorAll(
        '[data-see-it-work-dot]'
      )
    );

    if (!track || !slides.length) {
      return;
    }


    /* =========================================================
       SLIDER MODE
       1-4 videos  = desktop grid
       5+ videos   = desktop slider
       Mobile      = always slider
    ========================================================= */

    const DESKTOP_VISIBLE = 4;

    function updateSliderMode() {
      const desktopSlider =
        slides.length > DESKTOP_VISIBLE;

      section.classList.toggle(
        'see-it-work--has-desktop-slider',
        desktopSlider
      );

      section.dataset.slideCount =
        slides.length;
    }

    updateSliderMode();


    /* =========================================================
       VIDEO PLAY
    ========================================================= */

    slides.forEach(function (slide) {

      const video = slide.querySelector(
        '.see-it-work__video'
      );

      const playButton = slide.querySelector(
        '[data-video-play]'
      );

      const videoWrap = slide.querySelector(
        '.see-it-work__video-wrap'
      );

      if (!video || !playButton || !videoWrap) {
        return;
      }


      /* -------------------------------------------------------
         iOS / Safari
      ------------------------------------------------------- */

      video.setAttribute(
        'playsinline',
        ''
      );

      video.setAttribute(
        'webkit-playsinline',
        ''
      );


      /* -------------------------------------------------------
         PLAY BUTTON
      ------------------------------------------------------- */

      // playButton.addEventListener(
      //   'pointerdown',
      //   function (event) {

      //     /*
      //      * IMPORTANT:
      //      * Play button must NEVER start slider drag.
      //      */

      //     event.stopPropagation();

      //   },
      //   {
      //     passive: true
      //   }
      // );


      // playButton.addEventListener(
      //   'click',
      //   function (event) {

      //     event.preventDefault();
      //     event.stopPropagation();


      //     /*
      //      * Pause every other video.
      //      */

      //     slides.forEach(function (otherSlide) {

      //       if (otherSlide === slide) {
      //         return;
      //       }

      //       const otherVideo =
      //         otherSlide.querySelector(
      //           '.see-it-work__video'
      //         );

      //       const otherWrap =
      //         otherSlide.querySelector(
      //           '.see-it-work__video-wrap'
      //         );

      //       if (otherVideo) {
      //         otherVideo.pause();
      //       }

      //       if (otherWrap) {
      //         otherWrap.classList.remove(
      //           'is-playing'
      //         );
      //       }

      //     });


      //     /*
      //      * Play selected video.
      //      */

      //     try {

      //       const playPromise =
      //         video.play();

      //       if (
      //         playPromise &&
      //         typeof playPromise.then === 'function'
      //       ) {

      //         playPromise
      //           .then(function () {

      //             videoWrap.classList.add(
      //               'is-playing'
      //             );

      //           })
      //           .catch(function (error) {

      //             console.warn(
      //               'See It Work: video could not play.',
      //               error
      //             );

      //           });

      //       } else {

      //         videoWrap.classList.add(
      //           'is-playing'
      //         );

      //       }

      //     } catch (error) {

      //       console.warn(
      //         'See It Work: video play error.',
      //         error
      //       );

      //     }

      //   }
      // );

      playButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          /*
          * If this video is already playing:
          * PAUSE it.
          */
          if (!video.paused && !video.ended) {

            video.pause();

            videoWrap.classList.remove(
              'is-playing'
            );

            return;
          }


          /*
          * Pause every other video.
          */
          slides.forEach(function (otherSlide) {

            if (otherSlide === slide) {
              return;
            }

            const otherVideo =
              otherSlide.querySelector(
                '.see-it-work__video'
              );

            const otherWrap =
              otherSlide.querySelector(
                '.see-it-work__video-wrap'
              );

            if (otherVideo) {
              otherVideo.pause();
            }

            if (otherWrap) {
              otherWrap.classList.remove(
                'is-playing'
              );
            }

          });


          /*
          * Play selected video.
          */
          try {

            const playPromise =
              video.play();

            if (
              playPromise &&
              typeof playPromise.then === 'function'
            ) {

              playPromise
                .then(function () {

                  videoWrap.classList.add(
                    'is-playing'
                  );

                })
                .catch(function (error) {

                  console.warn(
                    'See It Work: video could not play.',
                    error
                  );

                });

            } else {

              videoWrap.classList.add(
                'is-playing'
              );

            }

          } catch (error) {

            console.warn(
              'See It Work: video play error.',
              error
            );

          }

        }
      );

      /* -------------------------------------------------------
        CLICK VIDEO TO PAUSE
      ------------------------------------------------------- */

      video.addEventListener(
        'click',
        function (event) {

          /*
          * Prevent video click from triggering
          * parent click events.
          */
          event.preventDefault();
          event.stopPropagation();


          /*
          * If video is playing,
          * pause it.
          */
          if (!video.paused && !video.ended) {

            video.pause();

            videoWrap.classList.remove(
              'is-playing'
            );

          }

        }
      );


      /* -------------------------------------------------------
        VIDEO PLAY / PAUSE EVENTS
      ------------------------------------------------------- */

      video.addEventListener(
        'play',
        function () {

          videoWrap.classList.add(
            'is-playing'
          );

        }
      );

      video.addEventListener(
        'pause',
        function () {

          videoWrap.classList.remove(
            'is-playing'
          );

        }
      );

      video.addEventListener(
        'ended',
        function () {

          videoWrap.classList.remove(
            'is-playing'
          );

        }
      );


      /* -------------------------------------------------------
         VIDEO ERROR
      ------------------------------------------------------- */

      video.addEventListener(
        'error',
        function () {

          console.warn(
            'See It Work: Video failed to load.'
          );

        }
      );

    });


    /* =========================================================
       DOT NAVIGATION
    ========================================================= */

    function goToSlide(index) {

      const slide = slides[index];

      if (!slide) {
        return;
      }

      const targetScroll =
        slide.offsetLeft -
        track.offsetLeft;

      track.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });

    }


    dots.forEach(function (dot) {

      dot.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          const index =
            Number(
              dot.dataset.seeItWorkDot
            );

          goToSlide(index);

        }
      );

    });


    /* =========================================================
       ACTIVE DOT
    ========================================================= */

    function updateActiveDot(index) {

      dots.forEach(function (
        dot,
        dotIndex
      ) {

        const active =
          dotIndex === index;

        dot.classList.toggle(
          'is-active',
          active
        );

        dot.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );

      });

    }


    /* =========================================================
       UPDATE DOT FROM SCROLL
    ========================================================= */

    let scrollTimer = null;

    track.addEventListener(
      'scroll',
      function () {

        window.clearTimeout(
          scrollTimer
        );

        scrollTimer =
          window.setTimeout(
            function () {

              let closestIndex = 0;
              let closestDistance =
                Infinity;

              slides.forEach(
                function (
                  slide,
                  index
                ) {

                  const slideCenter =
                    slide.offsetLeft +
                    slide.offsetWidth / 2;

                  const trackCenter =
                    track.scrollLeft +
                    track.clientWidth / 2;

                  const distance =
                    Math.abs(
                      slideCenter -
                      trackCenter
                    );

                  if (
                    distance <
                    closestDistance
                  ) {

                    closestDistance =
                      distance;

                    closestIndex =
                      index;

                  }

                }
              );

              updateActiveDot(
                closestIndex
              );

            },
            80
          );

      },
      {
        passive: true
      }
    );


    /* =========================================================
       MOUSE DRAG + TOUCH SWIPE
    ========================================================= */

    let isDragging = false;
    let hasDragged = false;

    let startX = 0;
    let startScrollLeft = 0;

    let activePointerId = null;

    const DRAG_THRESHOLD = 8;


    /* ---------------------------------------------------------
       POINTER DOWN
    --------------------------------------------------------- */

    track.addEventListener(
      'pointerdown',
      function (event) {

        /*
         * NEVER start drag from play button.
         */

        if (
          event.target.closest(
            '[data-video-play]'
          )
        ) {
          return;
        }


        /*
         * Desktop:
         * only left mouse button.
         */

        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }


        isDragging = true;
        hasDragged = false;

        activePointerId =
          event.pointerId;

        startX =
          event.clientX;

        startScrollLeft =
          track.scrollLeft;

        /*
         * Do NOT add is-dragging
         * immediately.
         *
         * It will be added only after
         * actual movement happens.
         */

      },
      {
        passive: true
      }
    );


    /* ---------------------------------------------------------
       POINTER MOVE
    --------------------------------------------------------- */

    track.addEventListener(
      'pointermove',
      function (event) {

        if (
          !isDragging ||
          event.pointerId !==
            activePointerId
        ) {
          return;
        }


        const deltaX =
          event.clientX -
          startX;


        /*
         * Only consider it a drag
         * after threshold.
         */

        if (
          Math.abs(deltaX) <=
          DRAG_THRESHOLD
        ) {
          return;
        }


        if (!hasDragged) {

          hasDragged = true;

          track.classList.add(
            'is-dragging'
          );

        }


        /*
         * Move slider opposite
         * to mouse/finger direction.
         */

        track.scrollLeft =
          startScrollLeft -
          deltaX;


        /*
         * Stop browser selection
         * after real drag starts.
         */

        if (
          event.pointerType === 'mouse'
        ) {
          event.preventDefault();
        }

      },
      {
        passive: false
      }
    );


    /* ---------------------------------------------------------
       STOP DRAG
    --------------------------------------------------------- */

    function stopDrag(event) {

      if (
        event.pointerId !==
        activePointerId
      ) {
        return;
      }


      isDragging = false;


      track.classList.remove(
        'is-dragging'
      );


      try {

        if (
          track.hasPointerCapture(
            event.pointerId
          )
        ) {

          track.releasePointerCapture(
            event.pointerId
          );

        }

      } catch (error) {
        /* Safari fallback */
      }


      activePointerId = null;


      /*
       * If user dragged, keep a temporary
       * click-block flag.
       */

      if (hasDragged) {

        window.setTimeout(
          function () {

            hasDragged = false;

          },
          80
        );

      }

    }


    track.addEventListener(
      'pointerup',
      stopDrag
    );

    track.addEventListener(
      'pointercancel',
      stopDrag
    );


    /* ---------------------------------------------------------
       PREVENT CLICK AFTER REAL DRAG
    --------------------------------------------------------- */

    track.addEventListener(
      'click',
      function (event) {

        /*
         * IMPORTANT:
         * Play button click is allowed.
         */

        if (
          event.target.closest(
            '[data-video-play]'
          )
        ) {
          return;
        }


        if (hasDragged) {

          event.preventDefault();
          event.stopPropagation();

          hasDragged = false;

        }

      },
      true
    );


    /* =========================================================
       PAUSE VIDEO WHEN SLIDE LEAVES VIEW
    ========================================================= */

    if (
      'IntersectionObserver' in window
    ) {

      const videoObserver =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  entry.isIntersecting
                ) {
                  return;
                }

                const video =
                  entry.target.querySelector(
                    '.see-it-work__video'
                  );

                if (video) {
                  video.pause();
                }

              }
            );

          },
          {
            root: track,
            threshold: 0.1
          }
        );


      slides.forEach(
        function (slide) {

          videoObserver.observe(
            slide
          );

        }
      );

    }

  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initAllSeeItWork() {

    const sections =
      document.querySelectorAll(
        '.see-it-work'
      );

    sections.forEach(
      function (section) {

        initSeeItWork(section);

      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllSeeItWork
    );

  } else {

    initAllSeeItWork();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.see-it-work'
        );

      if (section) {

        initSeeItWork(
          section
        );

      }

    }
  );


})();